export default __webpack_public_path__ + "static/media/img-egt@2x.73ed1821.png";